
  import { mapState } from 'vuex'
  import { Button as wdButton, MessageBox } from '@wenjuan/ui2'

  export default {
    name: 'PageJubao',
    components: {
      wdButton,
    },
    layout: 'template-page',
    data() {
      return {
        dialogVisible: false,
        currentItem: null,
        reportList: [
          {
            id: 'phone',
            title: '举报电话',
            icon: 'phone-line.svg',
            type: 'dialog',
            dialogContent: [{ value: '4006-700-778' }],
          },
          {
            id: 'email',
            title: '举报邮箱',
            icon: 'mail-line.svg',
            type: 'dialog',
            dialogContent: [{ value: 'wenjuan@idiaoyan.com' }],
          },
          {
            id: 'form',
            title: '举报表单',
            icon: 'survey-line.svg',
            type: 'link',
            url: 'https://www.wenjuan.com/s/UZBZJvya9/',
          },
          {
            id: 'qq',
            title: '举报QQ',
            icon: 'qq-line.svg',
            type: 'dialog',
            dialogContent: [{ value: '569671542' }],
          },
          {
            id: 'batch',
            title: '批量举报',
            icon: 'folder-warning-line.svg',
            type: 'link',
            url: 'https://www.wenjuan.com/s/UZBZJvr9e5b/',
          },
          {
            id: 'enterprise',
            title: '涉企举报专区',
            icon: 'building-line.svg',
            type: 'link',
            url: '/about/sqjbzq/',
          },
          {
            id: 'sweep',
            title: '扫黑除恶举报',
            icon: 'national-emblem.svg',
            type: 'dialog',
            dialogContent: [
              { label: '全国扫黑除恶举报网站', value: '12389.mps.gov.cn' },
              { label: '全国扫黑除恶举报电话', value: '010-12389' },
              { label: '上海市扫黑除恶举报电话', value: '021-52397077' },
            ],
          },
          {
            id: 'cyber',
            title: '中央网信办举报中心',
            icon: 'wxb.svg',
            type: 'link',
            url: 'https://www.12377.cn/',
          },
          {
            id: 'shanghai',
            title: '上海市互联网违法和不良信息举报中心',
            icon: 'wxb.svg',
            type: 'link',
            url: 'https://www.shjbzx.cn/',
          },
        ],
      }
    },
    head() {
      return {
        title: '举报专区_问卷网',
        bodyAttrs: {
          class: 'jubao-body',
        },
      }
    },
    computed: {
      ...mapState(['isMobile']),
      STATIC_DOMAIN() {
        return STATIC_DOMAIN
      },
    },
    mounted() {
      const reportUrl = this.$route.query.url
      if (reportUrl) {
        const formItem = this.reportList.find((i) => i.id === 'form')
        if (formItem) formItem.url = reportUrl
      }
    },
    methods: {
      handleReport(item) {
        if (item.type === 'link' && item.url) {
          window.open(item.url, '_blank')
        } else if (item.type === 'dialog') {
          this.currentItem = item
          this.dialogVisible = true
        }
      },
      closeDialog() {
        this.dialogVisible = false
        this.currentItem = null
      },
    },
  }
